<template>
  <div class="notification_item items-start" :class="{ unseen: !isRead }">
    <ProfileIcon :data="senderName" />

    <div class="flex flex-col gap-[6px] flex-grow min-w-0">
      <span class="proxima_nova text-sm font-normal text_color"
        ><span class="font-bold break-words content-wrapper">{{
          senderName
        }}</span>
        mentioned you in a <span class="font-bold"> comment.</span></span
      >
      <div v-if="entityType" class="flex flex-row items-center">
        <ThemeImage :icon="entityIcon" alt="icon" class="w-4 h-4 mr-1" />
        <span class="proxima_nova text-xs font-semibold text_color">{{
          entityName
        }}</span>
      </div>
      <span
        class="proxima_nova text_color text-sm break-words content-wrapper truncate_content"
      >
        <CommentContent :content="content" />
      </span>
      <div class="secondary_color text-xs text-nowrap">
        {{ formatTimestamp(createdTime, "timestamp", formatTypes.centered) }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { formatTimestamp } from "@/src/utils/dateTimeUtils.js";
import { formatTypes } from "@/src/constants/dateTimeConstants.js";
import CommentContent from "@/src/components/comments_components/CommentContent.vue";
import ProfileIcon from "@/src/components/ProfileIcon.vue";
import { imageNames } from "@/src/constants/imageConstants.js";

const props = defineProps({
  senderName: {
    type: String,
    required: true,
  },
  entityType: {
    type: String,
    default: null,
  },
  entityName: {
    type: String,
    default: null,
  },
  content: {
    type: Array,
    default: null,
  },
  createdTime: {
    type: String,
    required: true,
  },
  isRead: {
    type: Boolean,
    required: true,
  },
});

const entityIconMap = {
  company: imageNames.COMPANIES_UNSELECTED,
  deal: imageNames.DEALS_UNSELECTED,
  contact: imageNames.CONTACTS_UNSELECTED,
  lead: imageNames.LEADS_UNSELECTED,
  action: imageNames.ACTIONS_UNSELECTED,
  meeting: imageNames.MEETINGS_UNSELECTED,
};

const entityIcon = computed(() => {
  const entityType = props.entityType?.toLowerCase() || "";
  return entityIconMap[entityType] || "";
});
</script>

<style scoped>
.notification_item {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;
  border-radius: 8px;
}

.notification_item.unseen {
  border-radius: 8px;
  background: rgba(112, 149, 235, 0.12);
}

.notification_item:hover {
  background-color: var(--white-opacity-8);
}

.notification_item.unseen:hover {
  background:
    linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.08) 0%,
      rgba(255, 255, 255, 0.08) 100%
    ),
    rgba(112, 149, 235, 0.12);
}

.truncate_content {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
